import create from 'zustand';
import { devtools } from 'zustand/middleware';
import api from '../lib/api';

const VENDOR_STORAGE_KEY = 'CLAIMED_VENDOR';

const vendorStore = (set, get) => ({
  vendor: null,
  vendorLoading: false,
  vendorError: null,

  fetchMyVendor: async () => {
    set({ vendorLoading: true, vendorError: null });
    try {
      const res = await api.get('/api/directory/vendors/mine/');
      const vendors = res.data;
      const vendor =
        Array.isArray(vendors) && vendors.length > 0 ? vendors[0] : null;

      if (vendor) {
        localStorage.setItem(VENDOR_STORAGE_KEY, JSON.stringify(vendor));
      }

      set({ vendor, vendorLoading: false });
      return vendor;
    } catch (err) {
      console.error('Failed to fetch vendor:', err);
      set({ vendorLoading: false, vendorError: err.message });
      return null;
    }
  },

  getVendorId: () => {
    const { vendor } = get();
    return vendor?.id ?? null;
  },

  getVendorVerified: () => {
    const { vendor } = get();
    return vendor?.verified ?? false;
  },

  updateVendor: async (vendorId, data) => {
    try {
      const res = await api.patch(`/api/directory/vendors/${vendorId}/`, data);
      const updated = res.data;
      localStorage.setItem(VENDOR_STORAGE_KEY, JSON.stringify(updated));
      set({ vendor: updated });
      return updated;
    } catch (err) {
      console.error('Failed to update vendor:', err);
      throw err;
    }
  },

  loadVendorFromStorage: () => {
    try {
      const stored = localStorage.getItem(VENDOR_STORAGE_KEY);
      if (stored && stored !== 'undefined' && stored !== 'null') {
        set({ vendor: JSON.parse(stored) });
      }
    } catch (e) {
      // ignore
    }
  },

  clearVendor: () => {
    localStorage.removeItem(VENDOR_STORAGE_KEY);
    set({ vendor: null, vendorLoading: false, vendorError: null });
  },
});

let useVendorStore;
if (process.env.NODE_ENV !== 'production') {
  useVendorStore = create(devtools(vendorStore));
} else {
  useVendorStore = create(vendorStore);
}

export default useVendorStore;
